import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigsLoaderService } from '../config-loader.service';
import { Item } from 'app/models/item.inferface';
import { ISuggestService } from 'app/shared/components/suggest-input/model/ISuggestService';

export interface Tenantstem extends Item {
  tenants: Item[];
}

@Injectable({
  providedIn: 'root'
})
export class TenantByNameSuggestService implements ISuggestService<Tenantstem> {

  private apiEndpoint = '';
  headers = new HttpHeaders().append('Content-Disposition', 'multipart/form-data');

  constructor(
    private httpClient: HttpClient,
    private config: ConfigsLoaderService,
  ) {
    this.apiEndpoint = this.config.apiUrl;
  }

  getSuggestByDescription(description: string): Observable<Tenantstem[]> {
    const params = new HttpParams()
      .append('description', description);
    // return null
    return this.httpClient.get<Tenantstem[]>(`${this.apiEndpoint}/DataSource/GetTenants/`+description)
      .pipe(
        map(response => {
          return response;
        }),
      );
  }
}


